import { roleLabel, roleSatisfies, type RoleExpectation } from './roles'

// A ⚠ marker shown next to a role-bearing selection when the selected identity's
// role doesn't match what the feature expects. Renders nothing when it matches
// (or when there's no selection yet). The full explanation lives in the title.
export function RoleMismatchIcon({ exp, role }: { exp: RoleExpectation; role: string | null | undefined }) {
  if (role === undefined) return null
  if (roleSatisfies(exp, role)) return null
  return (
    <span
      className="role-warn"
      role="img"
      aria-label="role mismatch"
      title={`This identity is ${roleLabel(role)} — ${exp.reason} Expected ${exp.who}.`}
    >
      ⚠
    </span>
  )
}

// The longer-form banner for the same condition, for placing under a selector.
export function RoleMismatchBanner({ exp, role }: { exp: RoleExpectation; role: string | null | undefined }) {
  if (role === undefined || roleSatisfies(exp, role)) return null
  return (
    <div className="banner warning" style={{ marginTop: 12, marginBottom: 0 }}>
      This identity is <code>{roleLabel(role)}</code> — {exp.reason} Normally you'd act as {exp.who}. It may be rejected by the server.
    </div>
  )
}
